import { AuthContext } from ".";
import { useContext } from "react";

export const useAuth = () => useContext(AuthContext);
